<template lang="pug">  
    router-view.home
</template>

<script>

export default {
  name: 'home',
  created() {    
    this.$router.push({path:window.location.pathname})
  },
}
</script>

<style scoped>
.home {
  width: 78%;
}
</style>
